import * as React from "react";
const SvgWarning24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 22,
        fill: "black",
        viewBox: "0 0 24 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9.38 2.141c1.145-2.05 4.095-2.05 5.24 0l8.593 15.397c1.116 2-.33 4.462-2.62 4.462H3.407c-2.29 0-3.736-2.463-2.62-4.462L9.38 2.14Zm3.493.975a1 1 0 0 0-1.746 0L2.533 18.512A1 1 0 0 0 3.407 20h17.186a1 1 0 0 0 .873-1.488L12.873 3.116ZM11 13.5v-7h2v7h-2Zm1 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
      clipRule: "evenodd"
    })
  );
export default SvgWarning24Px;
